// extracted by mini-css-extract-plugin
export default {"recruiter-wrap":"LPRecruiter_recruiter-wrap__XBVlx","content":"LPRecruiter_content__Zxo3M","titleWrap":"LPRecruiter_titleWrap__oDV+g","listWrap":"LPRecruiter_listWrap__UeTa6"};